import { Box, Slider, Typography, useTheme } from '@mui/material';
import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  selectColorsDistributionMergeFactor,
  setColorsDistributionMergeFactor,
} from '../../../services/data/impl/cube/cubeSlice';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { flexCenter } from '../../commonUI/cssClasses';
const BUCKET_MAX_SIZE = 36;

const ColorBucketSizeSlider: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const colorsMergeFactor = useAppSelector(selectColorsDistributionMergeFactor);
  const { t } = useTranslation();

  // Function to invert the slider values
  const invertValue = (value: number): number => BUCKET_MAX_SIZE - value;

  const handleChangeColorsMerging = useCallback(
    (value: number | number[]) => {
      const invertedValue = invertValue(value as number);
      dispatch(setColorsDistributionMergeFactor(invertedValue || 1));
    },
    [dispatch]
  );

  return (
    <Box
      sx={{
        width: '100%',
        minWidth: '225px',
        ...flexCenter,
        flexDirection: 'row',
      }}
    >
      <Slider
        sx={{
          width: '100%',
          m: '0 1rem',
          '&.Mui-disabled': {
            opacity: 0.3,
            color: theme.colors.darkTheme.grey.muted,
          },
        }}
        value={invertValue(colorsMergeFactor)}
        step={3}
        min={0}
        max={BUCKET_MAX_SIZE}
        onChange={(event, value) => handleChangeColorsMerging(value)}
      />

      <Typography sx={{ color: (theme) => theme.colors.common.white }}>
        {t('Buckets', { ns: 'ranch-view' })}
      </Typography>
    </Box>
  );
};

export default ColorBucketSizeSlider;
